import { render, staticRenderFns } from "./privacidadEN.vue?vue&type=template&id=455e4e8e&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "privacidadEN.vue"
export default component.exports